export default __webpack_public_path__ + "static/media/platforms_phone.34139e78.svg";